import React from "react";
import "./index.scss";
import { IMdaePopupProps } from "./index";
import Popup from "devextreme-react/popup";
import { Template } from "devextreme-react/core/template";
import ScrollView from "devextreme-react/scroll-view";
import $ from "jquery";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

export const DISABLE_ANIMATION_CONFIG: any =  { show: { delay: 0 } };

const setupPopupContentHeight = (e, autoHeight) => {
  const totalHeight = $($(e.component.content()).siblings(".dx-popup-title"))
    .parent(".dx-overlay-content")
    .height();
  const titleHeight = $(e.component.content())
    .siblings(".dx-popup-title")
    .outerHeight(true);
  let footerHeight = 0;

  $(e.component.content())
  .children()
    .children(".sys-mdae-popup-footer-container")
    .each(function() {
      footerHeight += $(this).outerHeight(true);
    });

  if (autoHeight) {
    const contentHeight = $(e.component.content())
      .find(".sys-mdae-popup-content-html")
      .height();
      const maxHeight = e.component.option("maxHeight");
      const scrollBarHeight =
        maxHeight && maxHeight > 0 && totalHeight + footerHeight >= maxHeight
          ? contentHeight - footerHeight
          : contentHeight + footerHeight;
      $(e.component.content())
        .children()
        .children(".sys-mdae-popup-content-scroll-bar")
        .height(scrollBarHeight);
  } else {
    $(e.component.content())
      .children()
      .children(".sys-mdae-popup-content-scroll-bar")
      .height(totalHeight - titleHeight - footerHeight - 7);
  }
};

const MdaePopup: React.FC<IMdaePopupProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <Popup
      {...props}
      wrapperAttr={{
        class: props.className || null,
        ...(props.wrapperAttr || {}),
      }}
      dragEnabled={true}
      onShown={(e) => {
        if (typeof props.onShown === "function") props.onShown(e);
        setupPopupContentHeight(e, props.autoHeight);
        setTimeout(function() {
          setupPopupContentHeight(e, props.autoHeight);
        });
      }}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        const setupPopupHeightResizeHandler = (resizeEvent) => {
          if (
            (resizeEvent?.isTrusted ||
              resizeEvent?.detail?.isResizeMdaePopup) &&
            e.component.option("visible")
          ) {
            e.component.repaint();
            setTimeout(function() {
              setupPopupContentHeight(e, props.autoHeight);
            });
          }
        };
        window.addEventListener("resize", setupPopupHeightResizeHandler);
        e.component.on("disposing", () => {
          window.removeEventListener("resize", setupPopupHeightResizeHandler);
        });
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_SELECT_BOX,
          e.component,
          dispatch
        );
      }}
    >
      <Template name={"title"} render={props.mdaeTitleRender}></Template>
      <ScrollView
        className={"sys-mdae-popup-content-scroll-bar"}
        height={"100%"}
        width={"100%"}
      >
        <div className="sys-mdae-popup-content-html">
          {props.mdaeContentRender && props.mdaeContentRender()}
          {props.mdaeContentRenderComponent}
        </div>
      </ScrollView>
      {props.mdaeFooterRender && props.mdaeFooterRender()}
      {props.mdaeFooterRenderComponent}
    </Popup>
  );
};

export default MdaePopup;
